import { useWallet } from "@buidlerlabs/hashgraph-react-wallets";
import { Button, Image, Modal, Stack } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { Fragment } from "react";
import { SUPPORTED_WALLETS, URLs } from "../../utils/constants";
import { WalletBtn } from "./WalletBtn";
import { IconWallet, IconX } from "@tabler/icons";
import { showNotification } from "@mantine/notifications";

export const ConnectWalletBtn = ({
  disabled = false,
  connectLabel = "Connect",
  disconnectLabel = "Disconnect"
}) => {
  const [modalOpened, { open: openModal, close: closeModal }] =
    useDisclosure(false);
  const { isConnected, disconnect, connector } = useWallet();
  const icon = connector?.config?.icons?.white;

  const handleDisconnect = async () => {
    try {
      await fetch(`${URLs.API}/auth/logout`, {
        credentials: "include",
        method: "GET",
        redirect: "follow"
      });

      await disconnect();
    } catch (error) {
      console.error(error);

      showNotification({
        icon: <IconX />,
        autoClose: 4000,
        color: "red",
        title: `Could not disconnect`,
        message:
          error.message ??
          "Something went wrong the the account cannot be properly disconnected",
        loading: false
      });
    }
  };

  return (
    <Fragment>
      <Modal
        title="Connect wallet"
        opened={modalOpened}
        onClose={closeModal}
        centered
      >
        <Stack>
          {SUPPORTED_WALLETS.map((wallet, index) => {
            return (
              <WalletBtn
                key={`${wallet.identifier}-${index}`}
                wallet={wallet}
                onConnected={closeModal}
              />
            );
          })}
        </Stack>
      </Modal>
      {isConnected ? (
        <Button
          onClick={handleDisconnect}
          leftIcon={<Image width="auto" height={15} src={icon} />}
          disabled={disabled}
        >
          {disconnectLabel}
        </Button>
      ) : (
        <Button
          onClick={openModal}
          leftIcon={<IconWallet size={20} />}
          disabled={disabled}
        >
          {connectLabel}
        </Button>
      )}
    </Fragment>
  );
};
